export type NoticeTone = 'neutral' | 'signal' | 'sealed' | 'refused';

export interface Notice {
  readonly tone: NoticeTone;
  readonly heading: string;
  readonly detail: string;
  /** Server error code, shown so a customer can quote it. */
  readonly code?: string | undefined;
  readonly correlationId?: string | undefined;
}

interface StatusNoticeProps {
  readonly notice: Notice | undefined;
}

/**
 * The page's single announcement region.
 *
 * One region, always present in the DOM, whose contents change. A region that is added
 * and removed is not reliably announced, which would silently make every one of these
 * messages sighted-only — and the error states are the substance of the demo.
 *
 * `polite` rather than `assertive`: these follow an action the user just took, so they
 * do not need to interrupt.
 */
export function StatusNotice({ notice }: StatusNoticeProps) {
  return (
    <div role="status" aria-live="polite">
      {notice ? (
        <div className={`notice notice--${notice.tone}`}>
          <div className="notice__head">
            <strong>{notice.heading}</strong>
            {notice.code ? <span className="notice__code">{notice.code}</span> : null}
          </div>
          <p>{notice.detail}</p>
          {notice.correlationId ? (
            <p className="notice__code" style={{ marginTop: '0.375rem' }}>
              reference {notice.correlationId}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
